import Card from '../Card/Card';
import StageCard from '../StageCard/StageCard';
import styles from './CardGrid.module.scss';
import type { CardGridProps } from './interfaces';

const CardGrid = ({
  items,
  showStageCard = true,
  showCardsText = false,
}: CardGridProps) => {
  const [stageCardItem, ...restCardItems] = items;

  const cards = (showStageCard ? restCardItems : items).map(
    ({ text, ...props }) => (
      <article key={props.headline}>
        <Card {...props} text={showCardsText ? text : undefined} />
      </article>
    )
  );

  return (
    <div className={styles.base}>
      {showStageCard && stageCardItem && (
        <StageCard
          image={stageCardItem.image}
          headline={stageCardItem.headline}
          text={stageCardItem.text}
          tag={stageCardItem.tag}
          buttonText="Mehr erfahren"
          linkintern={stageCardItem.linkintern}
          date={stageCardItem.date}
        />
      )}
      {!!cards.length && <div className={styles.grid}>{cards}</div>}
    </div>
  );
};

export default CardGrid;
